import { useState, useRef } from 'react';
import * as React from 'react';
import SearchAutocomplete, { type ISearchAutocompleteState } from '../Shared/SearchAutocomplete';
import { TranslationService } from '../../services/translation.service';
import { ConfigurationService } from '../../services/configuration.service';
import './style.scss';
import type { IFindAutocompleteItem } from '../Shared/SearchAutocomplete/models/find-autocomplete-item.model';
import { Panels } from '../Shared/AutocompleteBase/autocomplete-base.enum';
import { t } from '../../services/texts.service';

function SiteSearchDesktop() {
  const [isAutoCompleteOpen, setIsAutoCompleteOpen] = useState(false);
  const [autocompleteState, setAutompleteState] = useState<ISearchAutocompleteState>({ value: { searchText: '', selectedItem: undefined, preventSearch: false } });
  const formRef = useRef<HTMLFormElement>(null);

  const searchPageUrl = ConfigurationService.get('sitesearch.searchpageurl');

  function handleOnCloseButtonClick() {
    setAutompleteState({ value: { searchText: '', selectedItem: undefined, preventSearch: false } });
  }

  function handleOnAutocompletePanelsChange(newPanel: Panels) {
    setIsAutoCompleteOpen(newPanel === Panels.suggestions);
  }

  function handleOnSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!autocompleteState.value.searchText) {
      e.preventDefault();
    }
  }

  function handleOnSearchTextChange(newSearchText: string) {
    setAutompleteState({ value: { searchText: newSearchText, selectedItem: undefined, preventSearch: false } });
  }

  function handleOnSelect(item: IFindAutocompleteItem | undefined) {
    if (!item) return;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('q', item.query);
    window.location.href = `${searchPageUrl}?${searchParams.toString()}`;
  }

  return (
    <form
      ref={formRef}
      action={searchPageUrl}
      method="get"
      role="search"
      aria-label={TranslationService.get('common.searchforms.labels.website')}
      className="d-none d-md-block site-search-desktop"
      onSubmit={handleOnSubmit}
    >
      <div
        className={`site-search-desktop__container d-flex position-relative container-fluid py-2 align-items-center ${isAutoCompleteOpen ? 'site-search-desktop__container--autocomplete-opened' : ''}`}
      >
        <SearchAutocomplete
          id="search-autocomplete-desktop"
          className="site-search-desktop-header-autocomplete flex-grow-1 me-2"
          placeholderText={TranslationService.get('common.search')}
          state={autocompleteState}
          labelText={TranslationService.get('common.search')}
          inputName="q"
          positionRelative={false}
          onSelect={handleOnSelect}
          onSearchTextChange={handleOnSearchTextChange}
          onPanelsChange={handleOnAutocompletePanelsChange}
        />
        <div className="d-none d-sm-inline-block align-self-stretch me-2">
          <button type="submit" className="btn btn-primary py-1 h-100">
            {TranslationService.get('common.search')}
          </button>
        </div>
        <button
          type="button"
          className="btn btn-tertiary ms-0"
          aria-label={t('Stäng sök', 'Close search')}
          data-bs-toggle="collapse"
          data-bs-target="#site-search-desktop-wrapper"
          aria-expanded="false"
          aria-controls="site-search-desktop-wrapper"
          onClick={handleOnCloseButtonClick}
        >
          {t('Stäng', 'Close')}
        </button>
      </div>
    </form>
  );
}

export default SiteSearchDesktop;
